<template>
  <div @click="handleGlobalClick" style="height:70vh;position: relative">
    <div style="display: flex;justify-content: space-between">
      <div>

<!--        <el-button type="danger" icon="el-icon-back" @click="$router.back()"></el-button>-->
<!--        <el-button type="danger" icon="el-icon-plus" @click="addRow()">行</el-button>-->
<!--        <el-button type="danger" icon="el-icon-plus" @click="addColumn">列</el-button>-->
        <div>
          <el-button type="danger" icon="el-icon-back" @click="$router.back()" style="margin-right: 10px"></el-button>
          <el-date-picker @blur="selectPerformance" :clearable="false" v-model="query.date" type="month"
                          value-format="yyyy-MM" style="width: 140px;margin-right: 10px" placeholder="选择月"/>
          <el-select v-model="templateType"  style="width: 140px" @change="choicePerformance">
            <el-tooltip v-if="updateList.plan == null" class="item" effect="dark" content="暂未提交计划表！" placement="top">
              <el-option disabled label="计划表" value="plan"/>
            </el-tooltip>
            <el-option v-else label="计划表" value="plan"/>
            <el-tooltip v-if="updateList.summary == null" class="item" effect="dark" content="暂未提交绩效表！" placement="top">
              <el-option disabled label="绩效表" value="summary"/>
            </el-tooltip>
            <el-option v-else label="绩效表" value="summary"/>
          </el-select>
          <el-tooltip class="item" effect="dark" content="下载Excel到本地！" placement="top">
            <el-button type="danger" style="margin-left: 10px" icon="el-icon-download" @click="exportExcel"></el-button>
          </el-tooltip>
        </div>
      </div>
      <el-tooltip class="item" effect="dark" content="只可查看，不可修改！" placement="top">
        <div class="only-read">{{updateItem.onlyRead == true ? '只读模式':''}}</div>
      </el-tooltip>

<!--      <el-popover placement="left" width="200" trigger="click" v-if="query.coachId == null && templateType == 'plan'">-->
<!--        <div style="margin-bottom: 20px">-->
<!--          <div style="margin-bottom: 8px;font-weight: bold">评分领导</div>-->
<!--          <el-select-->
<!--              v-model="updateItem.targetCoachId" style="width: 180px;margin:0 10px"-->
<!--              filterable placeholder="请选择发起人"-->
<!--              remote reserve-keyword :remote-method="selectCoach" clearable>-->
<!--            <el-option v-for="(coach,index) in coachList" :key="index" :label="coach.name" :value="coach.id">-->
<!--              {{coach.id}} - {{coach.name}}-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </div>-->
<!--        <div style="text-align: right; margin: 0;">-->
<!--          <el-button size="mini" @click="visible = false">取消</el-button>-->
<!--          <el-button type="danger" size="mini" @click="confirm">确定</el-button>-->
<!--        </div>-->
<!--        <el-button type="danger" :disabled="updateItem.onlyRead" slot="reference" icon="el-icon-check"></el-button>-->
<!--      </el-popover>-->

<!--      <el-popconfirm v-else title="确定保存本次操作吗？" @confirm="confirm">-->
<!--        <el-button type="danger" :disabled="updateItem.onlyRead" slot="reference" icon="el-icon-check"></el-button>-->
<!--      </el-popconfirm>-->
    </div>
    <el-table :header-row-style="{ height: '10px !important' }" :cell-style="{ padding: '0' }"
              v-loading="tableLoading"
              :span-method="mergeMethod" style="margin-top: 20px" empty-text="未检测到模板数据！" class="table"
              :data="this.tableData" border :row-style="{backgroundColor: '#FFFFFF'}" :highlight-selection-row="false"
              ref="tableRef">
      <el-table-column align="center" :width="item.width" v-for="(item, index) in this.headerData" :key="index" >
        <template #header>
          {{columnName[index]}}
        </template>
        <template #default="scope">
          <div @contextmenu.prevent="scope.row[index].setDialog = true" @click.stop>
            <el-popover placement="top" width="220" trigger="manual" v-model="scope.row[index].setDialog">
              <div>
                <div class="flex-between">
                  <div>Id:</div>
                  <el-input style="width: 100px" v-model="scope.row[index].id" size="mini"></el-input>
                </div>
                <div class="flex-between">
                  <div>只读: </div>
                  <el-switch v-model="scope.row[index].readonly" size="mini" :active-value="true" :inactive-value="false"></el-switch>
                </div>
                <div class="flex-between">
                  <div>字体颜色:</div>
                  <el-color-picker v-model="scope.row[index].fontColor" size="mini"></el-color-picker>
                </div>
                <div class="flex-between">
                  <div>背景颜色:</div>
                  <el-color-picker v-model="scope.row[index].backGroundColor" size="mini"></el-color-picker>
                </div>
                <div class="flex-between">
                  <div>大小：</div>
                  <el-slider style="margin:0 4px;width: 70%;" :format-tooltip="sizeTooltip" v-model="scope.row[index].fontSize"></el-slider>
                </div>
                <div class="flex-between">
                  <div>粗细：</div>
                  <el-slider style="margin:0 4px;width: 70%;" :step="100" :max="900" :format-tooltip="weightTooltip" v-model="scope.row[index].fontWeight"></el-slider>
                </div>
                <div style="margin-top: 6px;display: flex;justify-content: center">
                  <el-radio-group v-model="scope.row[index].textAlign" size="mini">
                    <el-radio-button label="left">靠左</el-radio-button>
                    <el-radio-button label="center">居中</el-radio-button>
                    <el-radio-button label="right">靠右</el-radio-button>
                  </el-radio-group>
                </div>
              </div>
              <template #reference>
                <div class="input-content-father" :style="';background-color:'+scope.row[index].backGroundColor">
                  <div class="input-content" v-html="scope.row[index].content" @blur="scope.row[index].content = $event.target.innerHTML"
                       @focus="handleGlobalClick()" contenteditable style="flex: 1"
                       :style="'color:'+scope.row[index].fontColor+
                    ';background-color:'+scope.row[index].backGroundColor+
                    ';text-align: '+scope.row[index].textAlign+
                    ';font-size: '+scope.row[index].fontSize+'px'+
                    ';font-weight: '+scope.row[index].fontWeight"/>
                </div>
              </template>
            </el-popover>
            <!-- 行高拖拽手柄 -->
            <div class="resize-handle" @mousedown="startResize(scope.$index)"></div>
          </div>
        </template>
      </el-table-column>
    </el-table>


  </div>
</template>
<script>
import {selectCoach} from '/src/api/contacts/user'
import {exportExcel, selectPerformance, updateMyPerformance} from "../../../../api/performance/performance";
export default {
  name: "SelectPerformance",
  data() {
    return {
      templateType:'plan',
      query:{
        date:null,
        year:null,
        month:null,
        coachId:null
      },
      updateItem: {
        onlyRead:true,
        targetCoachId:null
      },
      updateList:{
        plan:{},
        summary:{},
      },
      coachList:[],
      columnName:['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      tableData: [],
      tableLoading:false,
      headerData:[],
      rowIdCounter: 1000,
      // 存储每行的高度信息
      rowHeights: {},
      // 拖拽状态
      isResizing: true,
      currentRowIndex: null,
      startY: 0,
      initialHeight: 0,
    }
  },
  mounted() {
    // 监听鼠标释放事件
    document.addEventListener('mouseup', this.stopResize);
    document.addEventListener('mousemove', this.resizeRow);
  },
  beforeDestroy() {
    // 移除事件监听
    document.removeEventListener('mouseup', this.stopResize);
    document.removeEventListener('mousemove', this.resizeRow);
  },
  methods: {
    exportExcel(){
      const date = this.query.date.split('-');
      this.query.year = date[0];
      this.query.month = date[1];
      this.query.type = this.templateType == 'plan' ? 0:1;
      exportExcel(this.query).then(val=>{
        if (val.status == 200){
          let url = val.data;
          window.URL = window.URL || window.webkitURL;
          var name = url.substring(url.lastIndexOf("/") + 1, url.length);
          var xhr = new XMLHttpRequest();
          var a = document.createElement("a");
          xhr.open("GET", url, true);
          xhr.responseType = "blob";
          xhr.onload = function() {
            var file = new Blob([xhr.response], { type: "application/octet-stream" });
            a.href = window.URL.createObjectURL(file);
            a.download = name;
            a.click();
          };
          xhr.send();
        }
      })
    },
    handleGlobalClick() {
      for (const row of this.tableData) {
        for (const column of row) {
          column.setDialog = false;
        }
      }
    },
    sizeTooltip(val) {
      return ` ${val}px`
    },
    weightTooltip(val) {
      return ` ${val}`
    },
    /**
     * 新增行
     */
    addRow() {
      const rowId = ++this.rowIdCounter;
      let length = this.tableData[0].length;
      const newRow = Array.from({ length }, () => ({
        id: rowId,
        content: "",
        backGroundColor: "#FFFFFF",
        textAlign: "center",
        fontSize: 14,
        setDialog:false,
        height:30,
        readonly:false,
        fontWeight: 400,
        fontColor: '#303133'
      }));
      this.tableData = [...this.tableData, newRow];
      // 初始化新行的高度
      this.$nextTick(() => {
        const rows = this.$refs.tableRef.$el.querySelectorAll('.el-table__body tr');
        this.rowHeights[rows.length - 1] = rows[rows.length - 1].offsetHeight;
      });
    },
    addColumn(){
      const rowId = ++this.rowIdCounter;
      this.tableData.forEach((item,index) =>{
        item.push({ id: rowId, content: "",backGroundColor:"#FFFFFF",textAlign:"center",fontSize:14,fontWeight:400,fontColor:'#303133'});
        this.tableData[index]=item;
      })
      this.headerData.push({width:160})
    },
    /**
     *合并单元格
     */
    mergeMethod({ row, column, rowIndex, columnIndex }) {
      const currentId = row[columnIndex].id.toString();
      if (currentId >= 1000) return { rowspan: 1, colspan: 1 };
      const isTopLeftCell = (
          (columnIndex === 0 || row[columnIndex - 1].id.toString() !== currentId) &&
          (rowIndex === 0 || this.tableData[rowIndex - 1][columnIndex].id.toString() !== currentId)
      );
      if (!isTopLeftCell) return { rowspan: 0, colspan: 0 };

      let colspan = 1;//横向坐标
      for (let col = columnIndex + 1; col < row.length; col++) {
        if (row[col].id.toString() === currentId && row[col].id.toString() < 1000) colspan++;
        else break;
      }

      let rowspan = 1;//竖向坐标
      for (let rowIdx = rowIndex + 1; rowIdx < this.tableData.length; rowIdx++) {
        const cellId = this.tableData[rowIdx][columnIndex].id.toString();
        if (cellId === currentId && cellId < 1000) rowspan++;
        else break;
      }
      return { rowspan, colspan };
    },
    // 开始拖拽
    startResize(rowIndex) {
      this.isResizing = true;
      this.currentRowIndex = rowIndex;
      this.startY = event.clientY;
      this.initialHeight = this.rowHeights[rowIndex] || 30;
      // 更改鼠标样式
      document.body.style.cursor = 'row-resize';
    },
    // 拖拽过程中
    resizeRow(event) {
      if (!this.isResizing) return;
      const offsetY = event.clientY - this.startY;
      const newHeight = Math.max(30, this.initialHeight + offsetY);
      // 更新行高
      this.rowHeights[this.currentRowIndex] = newHeight;
      // 找到对应的表格行并应用高度
      this.$nextTick(() => {
        const rows = this.$refs.tableRef.$el.querySelectorAll('.el-table__body tr');
        if (rows[this.currentRowIndex]) {
          let tdList = rows[this.currentRowIndex].querySelectorAll("td");
          for (const td of tdList) {
            let textarea = td.querySelector("div .input-content-father");
            textarea.style.height = `${newHeight}px`;
          }
          rows[this.currentRowIndex].style.height = `${newHeight}px`;
        }
      });
    },
    // 结束拖拽
    stopResize() {
      this.isResizing = false;
      this.currentRowIndex = null;
      document.body.style.cursor = '';
      // 初始化新行的高度
      this.$nextTick(() => {
        const rows = this.$refs.tableRef.$el.querySelectorAll('.el-table__body tr');
        if (rows.length>0){
          this.rowHeights[rows.length - 1] = rows[rows.length - 1].offsetHeight;
        }
        for (const row of rows) {
          let tdList = row.querySelectorAll("td");
          for (const td of tdList) {
            let textarea = td.querySelector("div .input-content-father");
            textarea.style.height = `${td.offsetHeight-1}px`;
          }
        }
      });
    },
    // confirm(){
    //   if (this.tableData.length<1){
    //     this.$notify.warning({title: '警告', message: '未检测到模板数据，请先添加一行！'});return;
    //   }
    //   if (!this.updateItem.targetCoachId || this.updateItem.targetCoachId == '' || this.updateItem.targetCoachId==null){
    //     this.$notify.warning({title: '警告', message: '请选择您的上级评分领导！'});return;
    //   }
    //   const rows = this.$refs.tableRef.$el.querySelectorAll('.el-table__body tr');
    //   rows.forEach((row, rowIndex) => {
    //     let tdList = row.querySelectorAll("td");
    //     tdList.forEach((column, columnIndex) => {
    //       let textarea = column.querySelector("div .input-content-father");
    //       const width = textarea.clientWidth;
    //       this.tableData[rowIndex][columnIndex].width = width;
    //       this.tableData[rowIndex][columnIndex].height = textarea.offsetHeight;
    //     });
    //   });
    //   let header = [];
    //   let updateItem = this.updateItem;
    //   updateItem.list = this.tableData;
    //   const headerTh = this.$refs.tableRef.$el.querySelectorAll('.el-table__header tr th');
    //   for (const th of headerTh) {
    //     header.push({width:th.clientWidth+1});
    //   }
    //   header.length = header.length-1;
    //   this.updateItem.list = this.tableData;
    //   updateItem.list.push(header);
    //   updateMyPerformance(updateItem).then(val=>{
    //     if (val.status){
    //       this.tableData = [];
    //       this.updateItem = {name:"",coachList: [],list: []};
    //       this.$notify({title: '更新成功', message: '更新模板成功！', type: 'success'});
    //       this.selectPerformance();
    //     }else {
    //       this.$notify.error({title: '更新失败', message: val.data});
    //     }
    //   })
    // },
    /**
     * 查询我的或者需要我评分的绩效表
     */
    selectPerformance(){
      this.tableLoading = true;
      const date = this.query.date.split('-');
      this.query.year = date[0];
      this.query.month = date[1];
      selectPerformance(this.query).then(val=>{
        this.tableLoading = false;
        if (val.status == 200){
          this.updateList = val.data;
          if (val.data.plan != null){
            this.templateType = 'plan';
          } else if (val.data.summary != null) {
            this.templateType = 'summary';
          }else {
            this.$notify.error({title: '系统异常', message: '未检测到可以用模板！', offset: 40});
            return;
          }
          this.choicePerformance();
        }
      })
    },
    choicePerformance(){
      let performance = JSON.parse(JSON.stringify(this.updateList[this.templateType]));
      this.headerData = performance.list[performance.list.length-2];
      this.rowHeights = [];
      let rowHeights = performance.list[performance.list.length-1];
      rowHeights.forEach((item,index)=>{
        this.rowHeights[index] = item.height;
      })
      performance.list.length = performance.list.length-2;
      this.tableData = [...performance.list];
      this.updateItem = performance;
      this.selectCoach(this.updateItem.targetCoachId);
      // 初始化新行的高度
      this.$nextTick(() => {
        const rows = this.$refs.tableRef.$el.querySelectorAll('.el-table__body tr');
        rows.forEach((row, rowIndex) => {
          let tdList = row.querySelectorAll("td");
          let minHeight = Math.min(...this.tableData[rowIndex].map(item => item.height));
          tdList.forEach((column, columnIndex) => {
            let height = this.tableData[rowIndex][columnIndex].height;
            let textarea = column.querySelector("div .input-content-father");
            textarea.style.height = `${height}px`;
          });
          row.style.height = `${minHeight}px`;
          this.rowHeights[rowIndex] = minHeight;
        });
      });
    },
    /**
     * 查询教练
     */
    selectCoach(val){
      selectCoach({coachName:val ? val:''}).then(val=>{
        this.coachList = val.data;
      })
    },
  },
  created() {
    this.query = this.$route.query.item;
    this.query.date = this.query.year+'-'+this.query.month;
    this.selectPerformance();
  }
}
</script>
<style scoped>
/* 单元格内容样式 */
.cell-content {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 拖拽手柄样式 */
.resize-handle {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;

  height: 4px;
  cursor: row-resize;
  background-color: transparent;
  opacity: 0.5;
  transition: opacity 0.2s;
}
.flex-between{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.input-content-father{
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #7dcb57;
}
.resize-handle:hover {
  opacity: 1;
}
/* 为表格行添加样式 */
.el-table__body tr {
  transition: height 0.2s;
}
/* 使用/deep/或::v-deep穿透scoped样式 */
/deep/ .el-table .cell,
/deep/ .el-table th>.cell {
  padding: 0 !important;
}

/* 可选：移除单元格内内容的外边距 */
/deep/ .el-table .cell>div,
/deep/ .el-table .cell>span,
/deep/ .el-table .cell>button {
  margin: 0 !important;
}
/* 使用/deep/或::v-deep选择器覆盖默认样式 */
::v-deep .el-table__header-wrapper tr {
  height: 10px !important;
}
.table{
  width: 100%;
  border-radius: 10px;
  padding: 4px
}
::v-deep .el-table__header-wrapper th {
  padding: 2px 0; /* 减少内边距 */
}
::v-deep .el-cascader__tags{
  width: 68%;
  flex-wrap: nowrap;
}
.only-read{
  position: absolute;
  left: 50%;
  transform:translateX(-50%);
  color: red;
  font-weight: bold;
  font-size: 15px;
}
</style>
